import ExtendableError from 'utils/ExtendableError';

export default class WaveformGenerationError extends ExtendableError {
  constructor(message = 'Waveform generation failed') {
    super(message);
  }
}
